import React from "react";
var __jsx = React.createElement;
import SingleTrendCard from "./SingleTrendCard/SingleTrendCard";
import stl from "./TrendsList.module.css";
var TrendsList = function TrendsList(_ref) {
  var trendsList = _ref.trendsList,
    currentPage = _ref.currentPage;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: stl.TL_container
  }, trendsList.map(function (trend, idx) {
    return /*#__PURE__*/React.createElement(SingleTrendCard, {
      key: idx,
      trend: trend,
      isEager: idx <= 2,
      currentPage: currentPage
    });
  })));
};
export default TrendsList;